import { AlertTriangle, RotateCcw } from 'lucide-react'
import { Button } from './Button'

interface ErrorStateProps {
  title?: string
  message?: string
  onRetry?: () => void
}

export function ErrorState({ title = 'Error al cargar los datos', message, onRetry }: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <div className="w-12 h-12 rounded-full bg-error-50 flex items-center justify-center mb-3">
        <AlertTriangle className="w-6 h-6 text-error-500" />
      </div>
      <h3 className="text-sm font-semibold text-text-primary mb-1">{title}</h3>
      {message && <p className="text-xs text-text-tertiary mb-4 max-w-xs">{message}</p>}
      {onRetry && (
        <Button size="sm" variant="secondary" onClick={onRetry}>
          <RotateCcw className="w-3.5 h-3.5 mr-1" />
          Reintentar
        </Button>
      )}
    </div>
  )
}
